import React from "react";

const Spinner = ()=>{
    return(
        <>
            <span class="spinner-border"></span> 
        </>
    )
}

export default Spinner;